import { createSlice } from "@reduxjs/toolkit";
import { ORG_TYPES } from "../components/Common/Constants";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: localStorage.getItem("authToken") !== null,
    dealerLayout:
      localStorage.getItem("userDetails")?.currentOrganisation?.type ===
      ORG_TYPES.DEALER,
    roles: [],
  },
  reducers: {
    setLoggedIn: (state) => {
      return {
        ...state,
        isLoggedIn: true,
      };
    },
    setLoggedOut: (state) => {
      return {
        ...state,
        isLoggedIn: false,
      };
    },
    setRoles: (state, action) => {
      return {
        ...state,
        roles: action.payload,
      };
    },
    setDealerLayout: (state, action) => {
      return {
        ...state,
        dealerLayout: action.payload,
      };
    },
  },
});

export const { setLoggedIn, setLoggedOut, setRoles, setDealerLayout } =
  authSlice.actions;
export default authSlice.reducer;
